import React from 'react';
import './sidebar-container.styles.scss';
import { useSelector } from 'react-redux';
import SidebarLeft from './sidebar-left.component';

const SidebarLeftContainer = ({ orgId, setShowBugModal }) => {
    
    const screenSize = useSelector(state => state.contentData.screenSize);

    return (
        <div className={`sidebar-left-container ${screenSize}`}>
            <div className={`${screenSize === 'desktop' && 'g-card'}`}>
                <SidebarLeft 
                    orgId={orgId} 
                    setShowBugModal={setShowBugModal} />
            </div>
        </div>
    )
}

export default SidebarLeftContainer